<div *ngIf="currentLang === 'ja'">
  <div class="manual-link">
    <a [href]="manualTopLink">使い方トップ</a> » 予約施設属性情報（追加・編集）の説明
  </div>

  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">

  <mat-card appearance="outlined" class="manual-card">
    <mat-card-header>
      <mat-card-title><span>予約施設属性情報（追加・編集）の説明</span></mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <div class="manual-img">
        <img src="assets/img/manual/reservation-facility-attr-dialog.png" width="100%">
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/A.png"> 閉じるボタン
      </div>
      <div class="manual-explain">
        クリックすることでダイアログを閉じます。<br>
        その際、編集した内容は保存されません。
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/B.png"> ID
      </div>
      <div class="manual-explain">
        IDを設定します。<br>
        <span class="manual-explain-notes">※必須項目</span>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/C.png"> 名称
      </div>
      <div class="manual-explain">
        名称を設定します。<br>
        編集ボタンから<a [href]="nameDialogLink">名称ダイアログ</a>を開き設定します。<br>
        <span class="manual-explain-notes">※必須項目</span>
      </div>

      <div class="manual-explain-title">
        <img src="assets/img/manual/D.png"> 更新ボタン
      </div>
      <div class="manual-explain">
        クリックすることで編集内容が更新されます。
      </div>

    </mat-card-content>
  </mat-card>

  </div>
</div>
<div *ngIf="currentLang === 'en'">
  <div class="manual-link">
    <a [href]="manualTopLink">User Guide Top</a> » Explanation of Reserved Facility Attribute Information (Add/Edit)
  </div>
  
  <div class="manual-main" fxLayout="row" fxLayoutAlign="start start" fxLayoutGap="20px">
  
    <mat-card class="manual-card">
      <mat-card-header>
        <mat-card-title><span>Explanation of Reserved Facility Attribute Information (Add/Edit)</span></mat-card-title>
      </mat-card-header>
  
      <mat-card-content>
        <div class="manual-img">
          <img src="assets/img/manual/en_reservation-facility-attr-dialog.png" width="100%">
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/A.png"> Close Button
        </div>
        <div class="manual-explain">
          Clicking this button will close the dialog.<br>
          Edited content will not be saved.
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/B.png"> ID
        </div>
        <div class="manual-explain">
          Set the ID.<br>
          <span class="manual-explain-notes">* Required field</span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/C.png"> Name
        </div>
        <div class="manual-explain">
          Set the name.<br>
          Open the <a [href]="nameDialogLink">Name Dialog</a> from the edit button to configure it.<br>
          <span class="manual-explain-notes">* Required field</span>
        </div>
  
        <div class="manual-explain-title">
          <img src="assets/img/manual/D.png"> Update Button
        </div>
        <div class="manual-explain">
          Clicking this button will apply the edited content.
        </div>
  
      </mat-card-content>
    </mat-card>
  
  </div>  
</div>
